const AuthLoading = () => (
  <div className="loading loading--screen dark-theme" role="status" aria-live="polite">
    <span className="visually-hidden">Signing you in…</span>
    <div className="spinner" />
  </div>
)

export default AuthLoading
